import AppState, { POPUPS } from "./AppState";
import PopupsManager from "react-sdk/PopupsManager";
import Minigames from "./Minigames/Minigames";
// import PathMgr from "./decarbonation/PathMgr";



class FtueHelper {

    ftueSteps = new Map();

    ftueDone = new Map();




    constructor() {
        this.ftueDone.set("map", [])
        this.ftueDone.set("activities", [])
        this.ftueDone.set("mgs", [])
    }

    initFtueFromFile(file) {
        
        
        file.map(ftue => {



            if(!this.ftueSteps.has(ftue.Id))
                this.ftueSteps.set(ftue.Id, ftue)
        })
    }

    get hasAnyDone() {
        if(!this.ftueSteps ||  this.ftueSteps.length === 0) return false

        return this.ftueSteps.values().some(v => v.done === true)
    }

    get displayftueButton() {


        return this.hasAnyDone || Minigames.current != null
    }

    handleftueButtonClick() {


        if(Minigames.current != null) {

            const ftues = window.CONFIG.mgFtues[Minigames.current.type]

            if(ftues && ftues.length > 0) {
                this.openFtues(ftues, "activities", true)
            }
        }
        else {
            this.showCarousel()
        }
    }

    hasShownFtue(id) {
        return this.ftueSteps.get(id)?.done;
    }

    flushDones(type = "map") {
        this.ftueDone.set(type, [])
    }

    showCarousel() {
       this.openFtues(this.ftueDone.get("map"), false)
    }

    openFtues(pageIds, type = "map", animated = false, cb = null) {


        const pages = pageIds.map(id => this.ftueSteps.get(id)).filter(p => p !== undefined && p !== null)

        if(pages.length === 0) {
            if(cb) cb()
            console.warn("openFtues: no pages to open")
            return;
        }

        var datas = {
            pages: pages,
            animated: animated
        }

        PopupsManager.open(POPUPS.FTUE, datas, () => {
            if(cb) cb()

            pages.forEach(p => { 
                if(p && !p.done) {
                    p.done = true
                    this.ftueDone.get(type).push(p.Id)
                }    
            })
        })
    }
}

export default new FtueHelper()